module.exports = __webpack_public_path__ + "img/UTSAND-6.3827bbc5.jpg";